interface FinalCTASectionProps {
  onGetFreeGuide: () => void;
}

export default function FinalCTASection({ onGetFreeGuide }: FinalCTASectionProps) {
  return (
    <section className="bg-[#0a1628] py-20 md:py-28 relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[700px] rounded-full bg-[#f5a623]/5 blur-3xl" />
        <div
          className="absolute inset-0 opacity-[0.025]"
          style={{
            backgroundImage: 'linear-gradient(#f5a623 1px, transparent 1px), linear-gradient(90deg, #f5a623 1px, transparent 1px)',
            backgroundSize: '50px 50px',
          }}
        />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-[#f5a623]/10 border border-[#f5a623]/30 rounded-full px-4 py-2 mb-8">
          <i className="ri-flag-2-fill text-[#f5a623] text-sm" />
          <span className="text-[#f5a623] font-body text-xs font-semibold uppercase tracking-widest">
            Don't Wait Another Season
          </span>
        </div>

        <h2 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white uppercase leading-tight mb-6">
          Your Athlete's Future
          <span className="block text-[#f5a623]">Starts Today.</span>
        </h2>

        <p className="font-body text-lg md:text-xl text-white/65 max-w-2xl mx-auto mb-10 leading-relaxed">
          Every season you wait is a season coaches don't know your athlete exists. The playbook is ready — <strong className="text-white">are you?</strong>
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="https://stan.store/The_RecruitingPlaybook/p/get-the-free-7step-playbook-now"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto border-2 border-white/40 text-white px-8 py-4 rounded-md font-body text-base font-semibold hover:border-white/80 hover:bg-white/5 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
          >
            Get the Free Guide
          </a>
          <a
            href="https://stan.store/The_RecruitingPlaybook/p/get-the-recruiting-playbook-now"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto bg-[#f5a623] text-[#0a1628] px-8 py-4 rounded-md font-body text-base font-extrabold hover:bg-[#f7b84b] transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
          >
            Get the Full Playbook — $47
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-5 mt-10">
          {['30-Day Guarantee', 'Instant Download', '12+ Templates Included'].map((item) => (
            <div key={item} className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-check-fill text-[#f5a623] text-base" />
              </div>
              <span className="font-body text-sm text-white/50">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
